// @core/api/endpoints/notifications/update_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTemplateRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update notification template
 * Updates an existing notification template. Changes will apply to all future notifications using this template.
 */
export async function UpdateTemplate(
  template_id: string,
  data: UpdateTemplateRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
